import React from 'react';

import { LinkButton, StandardButton } from '@eika/button';
import { ErrorCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { useNavigate } from '@domain/app';
import useText from '@hooks/use-text';

import CustomErrorCard from './CustomErrorCard';

import './ErrorCard.scss';

interface ErrorCardProps {
    hideBackToOverviewButton?: boolean;
}
interface ErrorCardWithTryAgainClick extends ErrorCardProps {
    tryAgainClick?: () => void;
}

interface CouldNotGetCardDetailsErrorCardProps {
    errorMessageText: string;
    tryAgainClick: () => void;
}

interface CardIsAlreadySoftBlockedErrorCardProps {
    goToHardBlock?: () => void;
}

export const CouldNotFetchCardsErrorCard = ({
    tryAgainClick,
    hideBackToOverviewButton = false,
}: ErrorCardWithTryAgainClick) => {
    const { messageErrorUps, cardListErrorText } = useText();

    return (
        <CustomErrorCard
            title={messageErrorUps}
            description={cardListErrorText}
            tryAgainClick={tryAgainClick}
            hideBackToOverviewButton={hideBackToOverviewButton}
        />
    );
};

export const CouldNotGetCardDetailsErrorCard = ({
    errorMessageText,
    tryAgainClick,
}: CouldNotGetCardDetailsErrorCardProps) => {
    const { messageErrorUps } = useText();

    return <CustomErrorCard title={messageErrorUps} description={errorMessageText} tryAgainClick={tryAgainClick} />;
};

export const CardIsAlreadySoftBlockedErrorCard = ({ goToHardBlock }: CardIsAlreadySoftBlockedErrorCardProps) => {
    const { messageErrorUps, blockCardCardIsAlreadySoftBlocked, genericGoBackToCardList, blockHardTitle } = useText();
    const navigate = useNavigate();

    return (
        <ErrorCard title={messageErrorUps} description={blockCardCardIsAlreadySoftBlocked}>
            <div className="error-container-buttons">
                {goToHardBlock && <StandardButton onClick={() => goToHardBlock()}>{blockHardTitle}</StandardButton>}
                <div className="bottom-button">
                    <LinkButton onClick={navigate('HOME_PAGE')}>{genericGoBackToCardList}</LinkButton>
                </div>
            </div>
        </ErrorCard>
    );
};

export const CouldNotFetchDocumentsErrorCard = ({
    tryAgainClick,
    hideBackToOverviewButton = false,
}: ErrorCardWithTryAgainClick) => {
    const { messageErrorUps, documentFetchError } = useText();

    return (
        <CustomErrorCard
            title={messageErrorUps}
            description={documentFetchError}
            tryAgainClick={tryAgainClick}
            hideBackToOverviewButton={hideBackToOverviewButton}
        />
    );
};

export const CouldNotFetchCustomerInfoErrorCard = ({
    tryAgainClick,
    hideBackToOverviewButton = false,
}: ErrorCardWithTryAgainClick) => {
    const { messageErrorUps, genericCouldNotFetchUserInfoError } = useText();

    return (
        <CustomErrorCard
            title={messageErrorUps}
            description={genericCouldNotFetchUserInfoError}
            tryAgainClick={tryAgainClick}
            hideBackToOverviewButton={hideBackToOverviewButton}
        />
    );
};

export const CouldNotFetchPINErrorCard = () => {
    const { messageErrorUps, pinErrorText } = useText();

    return (
        <CustomErrorCard
            className="half-padding-top"
            title={messageErrorUps}
            description={pinErrorText}
            icon={<RichIcon type={RichIconTypes.DATAFEIL_1} />}
            hideBackToOverviewButton
        />
    );
};

export const PINNotReadyErrorCard = () => {
    const { messageErrorUps, messageOrderCardPending } = useText();

    return (
        <CustomErrorCard
            className="half-padding-top"
            title={messageErrorUps}
            description={messageOrderCardPending}
            icon={<RichIcon type={RichIconTypes.KLOKKE} />}
            hideBackToOverviewButton
        />
    );
};
